<template>
<div :class="headless ? '' : 'card'">
  <div :class="headless ? 'text-center py-3' : 'card-body text-center'">
    <div class="row">
      <div class="col">
        <div><i class="fas fa-user fa-4x"></i></div>
        <div class="mt-2"><b>{{ user.name }} {{ user.surname }}</b></div>
        <div>{{ user.email }}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: ['user','headless'],
};
</script> 